import { render } from "./baseInput.vue?vue&type=template&id=b594b6d2"
import script from "./baseInput.vue?vue&type=script&lang=js"
export * from "./baseInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__